import { Link } from 'react-router-dom';
import styles from './LegalPage.module.css';

export default function PrivacidadPage() {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <Link to="/" className={styles.back}>← Volver al inicio</Link>

        <h1 className={styles.title}>Política de Privacidad y Tratamiento de Datos Personales</h1>
        <p className={styles.version}>Versión 1.0 · Septiembre de 2026</p>

        <section>
          <h2>1. Responsable del Tratamiento</h2>
          <p>En cumplimiento de la Ley 1581 de 2012 y el Decreto 1377 de 2013, <strong>Redeprog / Fenagro (Comercio Colaborativo)</strong> actúa como responsable del tratamiento de los datos personales recolectados a través de este sitio web y sus servicios asociados.</p>
          <p>Correo de contacto: <a href="mailto:privacidad@fenagro-oficial.org">privacidad@fenagro-oficial.org</a></p>
        </section>

        <section>
          <h2>2. Datos que Recolectamos</h2>
          <h3>Datos de lectores</h3>
          <ul>
            <li>Correo electrónico (solo si se registra voluntariamente)</li>
            <li>Datos de navegación: páginas visitadas, tiempo de lectura, dispositivo y ubicación aproximada</li>
            <li>Preferencias de contenido inferidas del comportamiento de navegación</li>
          </ul>
          <h3>Datos de anunciantes</h3>
          <ul>
            <li>Razón social, NIT y datos de contacto</li>
            <li>Información de facturación</li>
            <li>Material publicitario subido al sistema (imágenes, videos, audio)</li>
          </ul>
          <p><strong>No recolectamos</strong> datos sensibles ni datos de menores de 18 años.</p>
        </section>

        <section>
          <h2>3. Finalidades del Tratamiento</h2>
          <ul>
            <li>Publicar el periódico digital y personalizar la experiencia del lector</li>
            <li>Gestionar contratos publicitarios y facturación</li>
            <li>Enviar boletines informativos (solo con suscripción expresa)</li>
            <li>Mejorar el contenido y funcionamiento de la plataforma</li>
            <li>Cumplir obligaciones legales</li>
          </ul>
        </section>

        <section className={styles.destacado}>
          <h2>4. Almacenamiento en Servidores Internacionales</h2>
          <p>Comercio Colaborativo utiliza servicios de <strong>Google Cloud Platform y Firebase</strong>, cuyos servidores están ubicados principalmente en <strong>Estados Unidos (región us-central1)</strong>.</p>
          <p>Esta transferencia internacional es <strong>legal bajo la Ley 1581 de 2012 (art. 26)</strong> porque:</p>
          <ul>
            <li>Google LLC cuenta con certificaciones ISO 27001, SOC 2 Tipo II y cumple el GDPR europeo, reconocido por la SIC colombiana como nivel de protección adecuado.</li>
            <li>Google ha suscrito cláusulas contractuales estándar que satisfacen los requisitos del artículo 26 de la Ley 1581 de 2012.</li>
            <li>Los datos viajan cifrados en tránsito (TLS 1.3) y se almacenan cifrados en reposo (AES-256).</li>
          </ul>
          <p>Al usar este sitio, el usuario autoriza expresamente esta transferencia en las condiciones descritas.</p>
        </section>

        <section>
          <h2>5. Derechos del Titular</h2>
          <p>Puede ejercer los siguientes derechos escribiendo a <a href="mailto:privacidad@fenagro-oficial.org">privacidad@fenagro-oficial.org</a>:</p>
          <ul>
            <li>Conocer, actualizar o rectificar sus datos</li>
            <li>Revocar la autorización y solicitar supresión de sus datos</li>
            <li>Presentar quejas ante la Superintendencia de Industria y Comercio (SIC)</li>
          </ul>
          <p>Tiempo de respuesta: máximo 15 días hábiles.</p>
        </section>

        <section>
          <h2>6. Vigencia</h2>
          <p>Los datos se conservarán durante la vigencia de la relación comercial y por el tiempo que la ley exija (10 años para documentos comerciales según el Código de Comercio).</p>
        </section>

        <section>
          <h2>7. Cookies</h2>
          <p>Usamos cookies de sesión para la navegación y cookies analíticas (Google Analytics). Puede desactivarlas en la configuración de su navegador.</p>
        </section>

        <section>
          <h2>8. Modificaciones</h2>
          <p>Cualquier cambio sustancial será notificado en el sitio con al menos 10 días de anticipación. La versión vigente siempre estará disponible en esta página.</p>
        </section>

        <div className={styles.links}>
          <Link to="/terminos">Ver Términos y Condiciones →</Link>
        </div>
      </div>
    </div>
  );
}
